import ReportSelect from "./ReportSelect";

function WaterKernelUniqueDevices(props) {
  return <ReportSelect type={"water-kernel-unique-devices"} />;
}

export default WaterKernelUniqueDevices;
